// Shared, pure derivations over the Emerging Whole projection — used by the prose Big Picture and the read-only Essay Map so the two stay ONE
// interpretation of the same whole state (never two). No writes, no inference: labels come from the appraiser's sentences, statuses from the projection.
// NO CHARACTER TRUNCATION ANYWHERE: student-facing text is either an already-available safe semantic label (a quoted term, a short head) or the
// whole sentence, wrapped by the layout. Nothing is ever cut mid-word.
export const STANDING = { addressed: "addressed", worked_on: "worked on \u2014 not there yet", not_yet: "still missing" };
export const UNIT_STATUS = { written: "written", combined: "written \u2014 two ideas still together", unconnected: "written \u2014 not yet connected", partly: "written \u2014 partly" };
export const PART_NAME = { introduction: "Introduction", body: "Body", conclusion: "Conclusion" };

const whole = (label) => (label || "").replace(/\.$/, "").trim();

// the shortest SAFE label, or "" when none exists: one quoted term → that concept ("Success"); a "Verb it: …" instruction → its head ("Bring it together")
export const conceptTerm = (label) => {
  const t = whole(label);
  const quoted = [...t.matchAll(/(?<![\w])['\u2018"\u201c](\w[\w\s-]{0,28}\w|\w)['\u2019"\u201d](?![\w])/g)].map((m) => m[1].trim());
  if (quoted.length === 1) return quoted[0][0].toUpperCase() + quoted[0].slice(1);
  const head = t.split(":")[0];
  if (head.length < t.length && head.length <= 40) return head;
  return "";
};

// the safe short label when one exists, else the WHOLE sentence (wrapped by the layout) — never a truncation
export const conceptLabel = (label) => conceptTerm(label) || whole(label);

// the Body as an ARGUMENT MAP: concise requirement rows (entailed by the student's own claim), plus a unit row only when it carries a structural
// state of its own (two ideas together · not yet connected) or is cited by no shown requirement — never an inventory of storage units
export const bodyRows = (body) => {
  const needs = body.requirements.filter((r) => r.entailed);
  const cited = new Set(needs.flatMap((r) => r.unit_ids || []));
  const units = body.realization.filter((u) => u.status === "combined" || u.status === "unconnected" || !cited.has(u.unit_id));
  return [
    ...units.map((u) => ({ id: u.unit_id, kind: "unit", label: whole(u.label), status: UNIT_STATUS[u.status] || u.status, raw: u.status, current: false })),
    ...needs.map((r) => ({ id: r.id, kind: "need", label: conceptLabel(r.label), full: whole(r.label), current: r.status === "current", raw: r.standing, relations: r.source === "relations",
      status: r.source === "relations" && r.standing === "not_yet" ? "still needed" : STANDING[r.standing] || r.standing })),
  ];
};
